export enum ToastVariant {
  ERROR = 'danger',
  WARNING = 'warning',
  SUCCESS = 'success',
}
